import React from 'react';
import { language } from '@Language';
import { observer } from 'mobx-react-lite';
import { ReactComponent as OopsNotFound } from './assets/oops-not-found.svg'
import { ReactComponent as OopsNotFoundTablet } from './assets/oops-not-found-tablet.svg'
import { ReactComponent as OopsNotFoundMobile } from './assets/oops-not-found-mobile.svg'
import './SomeThingWrongPageStyle.scss'
import { Button } from 'antd';
import { storeBowser } from '@Stores/StoreBowser';
import { storeElement } from '@Stores/StoreElement';
import { useHistory } from 'react-router-dom';

const SomeThingWrongPage = observer((props) => {

    const history = useHistory()

    const defaultOnClick = () => {
        storeElement.SetSomethingWrongModal(false)
        history.push('/menu')
    }

    return (
        <div className='something-wrong--wrapper container'>
            <div className='something-wrong--title'>{props.title ? props.title : language.listen('somethingwrong_title')}</div>
            {(() => {
                if (storeBowser.isDesktop()) {
                    return <OopsNotFound />
                } else if (storeBowser.isTablet()) {
                    return <OopsNotFoundTablet />
                } else if (storeBowser.isMobile()) {
                    return <OopsNotFoundMobile />
                } else {
                    return <OopsNotFound />
                }
            })()}
            <div className='something-wrong--bottom'>
                <div className='something-wrong--message'>
                    {props.message ? props.message : language.listen('somethingwrong_message')}
                </div>
                <div className='something-wrong--button'>
                    <Button className='button' style={{ width: '100%' }} size='small' type="primary"
                        onClick={() => props.overrideButtonOnClick ? props.overrideButtonOnClick() : defaultOnClick()}>
                        {language.listen('somethingwrong_button')}
                    </Button>
                </div>
            </div>
        </div>
    );
})

export default SomeThingWrongPage;